import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export default function ContactMe() {

  const form = useRef();
    
      const SendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_cqwf1jr', 'template_9vp1hhd', form.current, 'RLVptYs1LmXuoikCr')
          .then(() => {              
              alert('Successfully sent mail to AB4S Team. Our team will get back to you as soon as possible. Thank you for contacting us.!');
          }, (error) => {
            alert(JSON.stringify(error));
          });
      };
  return (
    
    <section id="Contact">
      <div className="container" id="contact">
        <form ref={form} onSubmit={SendEmail}>
        <h2>Contact Me</h2>
        <div className="container contact">
          {/* LEFT: FORM */}
          <div className="contact-left">
                <input type="text" placeholder="Name" name="first_name" id="first_name" required></input>
                <input type="email" placeholder="Email" id="email" name="email" required/>
                <input type="text" placeholder="Mobile Number" id="number" name="number" required/>
                <input type="text" placeholder="Subject" id="subject" name="subject" required/>
                <textarea className="textarea" placeholder="Message" id="message" name="message" required></textarea>
                <input type="submit" id="button" value="Send Email" />    
          </div>
          {/* RIGHT: CONTACT INFO */}
          <div className="contact-right">
                <div className="contact-item">
                  <img src="./img/marker.png" alt="location" className="icon1" />
                  <div className="contact-info">
                    <h5 className="contact-info-title">Coimbatore, India</h5>
                </div>
                </div>

                <div className="contact-item">
                  <img src="./img/phone.png" alt="phone" className="icon1" />

                  <div className="contact-info">
                    <h5 title="Available on WhatsApp" className="contact-info-title">
                      🇮🇳 +91 9447057803
                    </h5>
                    <h5 title="Available on WhatsApp" className="contact-info-title">
                      🇮🇳 +91 8838538822
                    </h5>
                    <h5 title="Available on WhatsApp" className="contact-info-title">
                      🇮🇳 +91 9498036455
                    </h5>
                    <h5 title="Available on WhatsApp" className="contact-info-title">
                      🇬🇧 +44 7407834459
                    </h5>
                  </div>
                </div>

                <div className="contact-item">
                  <img src="./img/mail.png" alt="email" className="icon1" />
                  <div className="contact-info">
                    <h5 className="contact-info-title">ab4success.2023@gmail.com</h5>
                  </div>
                </div>
          </div>
          </div>
        </form>
        <script type="text/javascript" src="https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js"></script>
        <script type="text/javascript">emailjs.init('RLVptYs1LmXuoikCr')</script>
      </div>
  </section>  
  );  
}
